import { createContext, useContext } from 'react';

var DEFAULT_VARIANT = 'withRadio';
var RadioCardGroupContext = createContext({
    variant: DEFAULT_VARIANT,
});
var RadioCardGroupContextProvider = RadioCardGroupContext.Provider;
var useRadioCardGroup = function () { return useContext(RadioCardGroupContext); };

export { DEFAULT_VARIANT, RadioCardGroupContextProvider, useRadioCardGroup };
